import { ELEMENT_TYPES, API_METHOD_TYPES, LEAF_TYPES } from 'cg/components/documents/editor/slate/types'
import { Transforms, Path, Editor, Point, Range, Node, Element as SlateElement } from 'vendor/slate'
import { ReactEditor } from 'vendor/slate-react'
import { v4 as uuidv4 } from 'uuid'

const generateApiRequest = () => {
  const request = {
    type: ELEMENT_TYPES.api_request,
    skip_type_check: true,
    no_new_line_after_delete: true,
    parent: { type: ELEMENT_TYPES.api_tabs_content_item },
    children: [
      {
        type: ELEMENT_TYPES.table,
        noMargin: true,
        parent: { type: ELEMENT_TYPES.api_response },
        children: [
          {
            type: ELEMENT_TYPES.table_thead,
            parent: { type: ELEMENT_TYPES.table },
            children: [
              {
                type: ELEMENT_TYPES.table_tr,
                parent: { type: ELEMENT_TYPES.table_thead },
                children: [
                  {
                    id: `api-request-table-thead-${uuidv4()}`,
                    type: ELEMENT_TYPES.table_th,
                    addColumnsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_th },
                        children: [{ uuid: uuidv4(), text: 'Parameter', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-request-table-thead-${uuidv4()}-1`,
                    type: ELEMENT_TYPES.table_th,
                    addColumnsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_th },
                        children: [{ uuid: uuidv4(), text: 'Type', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-request-table-thead-${uuidv4()}-2`,
                    type: ELEMENT_TYPES.table_th,
                    addColumnsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_th },
                        children: [{ uuid: uuidv4(), text: 'Description', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: ELEMENT_TYPES.table_tbody,
            parent: { type: ELEMENT_TYPES.table },
            children: [
              {
                type: ELEMENT_TYPES.table_tr,
                parent: { type: ELEMENT_TYPES.table_tbody },
                children: [
                  {
                    id: `api-request-table-tbody-${uuidv4()}`,
                    type: ELEMENT_TYPES.table_td,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'id', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-request-table-tbody-${uuidv4()}-1`,
                    type: ELEMENT_TYPES.table_td,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'string', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-request-table-tbody-${uuidv4()}-2`,
                    type: ELEMENT_TYPES.table_td,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'enter description here...', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  }
                ]
              },
              {
                type: ELEMENT_TYPES.table_tr,
                parent: { type: ELEMENT_TYPES.table_tbody },
                children: [
                  {
                    id: `api-request-table-tbody-${uuidv4()}-3`,
                    type: ELEMENT_TYPES.table_td,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'name', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-request-table-tbody-${uuidv4()}-4`,
                    type: ELEMENT_TYPES.table_td,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'string', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-request-table-tbody-${uuidv4()}-5`,
                    type: ELEMENT_TYPES.table_td,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'enter description here...', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
  return request
}
const generateApiResponse = () => {
  const id = `api-code-${uuidv4()}`
  const firstTabId = `api-code-${uuidv4()}-1`

  const response = {
    type: ELEMENT_TYPES.api_response,
    skip_type_check: true,
    no_new_line_after_delete: true,
    parent: { type: ELEMENT_TYPES.api_tabs_content_item },
    children: [
      {
        type: ELEMENT_TYPES.table,
        noMargin: true,
        parent: { type: ELEMENT_TYPES.api_response },
        children: [
          {
            type: ELEMENT_TYPES.table_thead,
            parent: { type: ELEMENT_TYPES.table },
            children: [
              {
                type: ELEMENT_TYPES.table_tr,
                addRowsDisabled: true,
                parent: { type: ELEMENT_TYPES.table_thead },
                children: [
                  {
                    id: `api-response-table-${uuidv4()}`,
                    type: ELEMENT_TYPES.table_th,
                    addColumnsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_th },
                        children: [{ uuid: uuidv4(), text: 'Status Code', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  },
                  {
                    id: `api-response-table-${uuidv4()}-1`,
                    type: ELEMENT_TYPES.table_th,
                    addColumnsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_th },
                        children: [{ uuid: uuidv4(), text: 'Description', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: ELEMENT_TYPES.table_tbody,
            parent: { type: ELEMENT_TYPES.table },
            children: [
              {
                type: ELEMENT_TYPES.table_tr,
                addRowsDisabled: true,
                parent: { type: ELEMENT_TYPES.table_tbody },
                children: [
                  {
                    id: `api-response-table-${uuidv4()}`,
                    type: ELEMENT_TYPES.table_td,
                    addRowsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [
                          { uuid: uuidv4(), text: '404', [LEAF_TYPES.code]: true, parent: { type: ELEMENT_TYPES.default } }
                        ]
                      }
                    ]
                  },
                  {
                    id: `api-response-table-${uuidv4()}-1`,
                    type: ELEMENT_TYPES.table_td,
                    addRowsDisabled: true,
                    parent: { type: ELEMENT_TYPES.table_tr },
                    children: [
                      {
                        type: ELEMENT_TYPES.default,
                        parent: { type: ELEMENT_TYPES.table_td },
                        children: [{ uuid: uuidv4(), text: 'enter description here...', parent: { type: ELEMENT_TYPES.default } }]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id,
        type: ELEMENT_TYPES.code_tabs,
        noMargin: true,
        parent: { type: ELEMENT_TYPES.api_response },
        defaultActiveTab: firstTabId,
        single: true,
        children: [
          {
            type: ELEMENT_TYPES.code_tabs_header,
            noTabs: true,
            parent: { type: ELEMENT_TYPES.code_tabs },
            children: [
              {
                type: ELEMENT_TYPES.code_tabs_header_item,
                parent: { type: ELEMENT_TYPES.code_tabs_header },
                tabId: firstTabId,
                children: [{ uuid: uuidv4(), text: 'Title', parent: { type: ELEMENT_TYPES.code_tabs_header_item } }]
              }
            ]
          },
          {
            type: ELEMENT_TYPES.code_tabs_content_item,
            tabId: firstTabId,
            noTabs: true,
            parent: { type: ELEMENT_TYPES.code_tabs },
            language: 'plaintext',
            children: [
              {
                type: ELEMENT_TYPES.code_tabs_content_item_line,
                parent: { type: ELEMENT_TYPES.code_tabs_content_item },
                children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.code_tabs_content_item_line } }]
              }
            ]
          }
        ]
      }
    ]
  }
  return response
}

const insertApi = (editor, path) => {
  const id = `api-${uuidv4()}`
  const firstTabId = `api-tab-${uuidv4()}-1`
  const secondTabId = `api-tab-${uuidv4()}-2`

  const api = {
    type: ELEMENT_TYPES.api,
    children: [
      {
        type: ELEMENT_TYPES.api_method_and_title,
        parent: { type: ELEMENT_TYPES.api },
        children: [
          {
            type: ELEMENT_TYPES.api_method,
            method: API_METHOD_TYPES.get,
            parent: { type: ELEMENT_TYPES.api_method_and_title },
            children: [{ uuid: uuidv4(), text: '', parent: ELEMENT_TYPES.api_method }]
          },
          {
            type: ELEMENT_TYPES.api_title,
            parent: { type: ELEMENT_TYPES.api_method_and_title },
            children: [{ uuid: uuidv4(), text: 'Give a title to this method...', parent: { type: ELEMENT_TYPES.api_title } }]
          }
        ]
      },
      {
        type: ELEMENT_TYPES.api_path,
        parent: { type: ELEMENT_TYPES.api },
        children: [
          {
            uuid: uuidv4(),
            text: 'https://path.to.api/v1/method/:id',
            parent: { type: ELEMENT_TYPES.api_path }
          }
        ]
      },
      {
        type: ELEMENT_TYPES.api_description,
        parent: { type: ELEMENT_TYPES.api },
        children: [
          {
            uuid: uuidv4(),
            text: 'Briefly describe this method...',
            parent: { type: ELEMENT_TYPES.api_description }
          }
        ]
      },
      {
        id,
        type: ELEMENT_TYPES.api_tabs,
        defaultActiveTab: firstTabId,
        children: [
          {
            type: ELEMENT_TYPES.api_tabs_header,
            parent: { type: ELEMENT_TYPES.api_tabs },
            children: [
              {
                type: ELEMENT_TYPES.api_tabs_header_item,
                tabId: firstTabId,
                parent: { type: ELEMENT_TYPES.api_tabs_header },
                children: [{ uuid: uuidv4(), text: 'Request', parent: { type: ELEMENT_TYPES.api_tabs_header_item } }]
              },
              {
                type: ELEMENT_TYPES.api_tabs_header_item,
                tabId: secondTabId,
                parent: { type: ELEMENT_TYPES.api_tabs_header },
                children: [{ uuid: uuidv4(), text: 'Response', parent: { type: ELEMENT_TYPES.api_tabs_header_item } }]
              }
            ]
          },
          {
            type: ELEMENT_TYPES.api_tabs_content_item,
            parent: { type: ELEMENT_TYPES.api_tabs },
            tabId: firstTabId,
            children: [generateApiRequest()]
          },
          {
            type: ELEMENT_TYPES.api_tabs_content_item,
            parent: { type: ELEMENT_TYPES.api_tabs },
            tabId: secondTabId,
            children: [generateApiResponse()]
          }
        ]
      }
    ]
  }

  Transforms.insertNodes(editor, api, { at: path })
  ReactEditor.focus(editor)
}

const insertApiResponse = (editor, path) => {
  Transforms.insertNodes(editor, generateApiResponse(), { at: Path.next(path), select: true })
  ReactEditor.focus(editor)
}

const insertApiRequest = (editor, path) => {
  Transforms.insertNodes(editor, generateApiRequest(), { at: Path.next(path), select: true })
  ReactEditor.focus(editor)
}

const withApi = editor => {
  const { insertBreak, deleteBackward, deleteForward, deleteFragment, insertText, insertData } = editor

  // Prevent breaks on tab header item
  editor.insertBreak = () => {
    const { selection } = editor

    if (selection) {
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n =>
          !Editor.isEditor(n) &&
          [
            ELEMENT_TYPES.api_tabs_header_item,
            ELEMENT_TYPES.api_path,
            ELEMENT_TYPES.api_title,
            ELEMENT_TYPES.api_description
          ].includes(n.parent && n.parent.type)
      })

      if (match) {
        return
      }
    }

    insertBreak()
  }

  // Prevent node deletion on tab content and header items
  editor.deleteBackward = unit => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const { anchor } = selection
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n =>
          !Editor.isEditor(n) &&
          [
            ELEMENT_TYPES.api_tabs_header_item,
            ELEMENT_TYPES.api_tabs_content_item,
            ELEMENT_TYPES.api_path,
            ELEMENT_TYPES.api_title,
            ELEMENT_TYPES.api_description
          ].includes(n.parent && n.parent.type)
      })

      if (match) {
        const [, path] = match
        const start = Editor.start(editor, Path.parent(path))

        if (Point.equals(anchor, start)) {
          return
        }
      }
    }

    deleteBackward(unit)
  }

  // Prevent node deletion on tab content and header items
  editor.deleteForward = unit => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const { anchor } = selection
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n =>
          !Editor.isEditor(n) &&
          [
            ELEMENT_TYPES.api_tabs_content_item,
            ELEMENT_TYPES.api_tabs_header_item,
            ELEMENT_TYPES.api_path,
            ELEMENT_TYPES.api_title,
            ELEMENT_TYPES.api_description
          ].includes(n.parent && n.parent.type)
      })

      if (match) {
        const [node, path] = match
        if (node) {
          const end = Editor.end(editor, Path.parent(path))

          if (Point.equals(anchor, end)) {
            return
          }
        }
      }
    }

    deleteForward(unit)
  }

  editor.deleteFragment = () => {
    const { selection } = editor

    if (selection) {
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n =>
          !Editor.isEditor(n) &&
          [
            ELEMENT_TYPES.api_tabs_header_item,
            ELEMENT_TYPES.api_tabs_content_item,
            ELEMENT_TYPES.api_path,
            ELEMENT_TYPES.api_title,
            ELEMENT_TYPES.api_description
          ].includes(n.parent && n.parent.type)
      })

      if (match) {
        const [start, end] = Range.edges(selection)
        if (start.path.length !== end.path.length) return
        const startPathNode = Node.parent(editor, start.path)
        const endPathNode = Node.parent(editor, end.path)

        if (startPathNode.parent && endPathNode.parent && startPathNode.parent.type !== endPathNode.parent.type) return
      }
    }
    deleteFragment()
  }

  editor.insertText = text => {
    const { selection } = editor
    if (selection) {
      const [match] = Editor.nodes(editor, {
        at: selection,
        mode: 'lowest',
        match: n =>
          !Editor.isEditor(n) &&
          [
            ELEMENT_TYPES.api_tabs_header_item,
            ELEMENT_TYPES.api_tabs_content_item,
            ELEMENT_TYPES.api_method_and_title,
            ELEMENT_TYPES.api_path,
            ELEMENT_TYPES.api_title,
            ELEMENT_TYPES.api_description
          ].includes(n.parent && n.parent.type)
      })

      if (match) {
        const [start, end] = Range.edges(selection)
        if (start.path.length !== end.path.length) return
        const startPathNode = Node.parent(editor, start.path)
        const endPathNode = Node.parent(editor, end.path)

        if (startPathNode.parent && endPathNode.parent && startPathNode.parent.type !== endPathNode.parent.type) return
      }
    }

    insertText(text)
  }

  return editor
}
export { insertApi, insertApiRequest, insertApiResponse, withApi }
